// extracted by mini-css-extract-plugin
export default {"loader-overlay":"Loader_loader-overlay__4o0V4","loader":"Loader_loader__fX5DT","spin":"Loader_spin__v5K5h"};